export const USER_ROLE_KEYS = {
    MasterUser: 'MasterUser',
    SuperUser: 'SuperUser',
    NormalUser: 'NormalUser',
};

export const USER_ROLE_NAMES = {
    MasterUser: 'Forstjóri',
    SuperUser: 'Verkefnastjóri',
    NormalUser: 'Starfsmaður',
};